// extracted by mini-css-extract-plugin
module.exports = {"aiLabel":"aiLabel--53f5c"};